import React from 'react';
import { FEATURED_ITEMS } from '../homeData';

const HomeFeatured = () => (
  <div className="home-featured">
    {FEATURED_ITEMS.map((item) => (
      <article
        key={item.title}
        className={`home-featured__card${item.large ? ' home-featured__card--large' : ''}`}
      >
        <img src={item.image} alt={item.title} className="home-featured__image" />
        <div className="home-featured__overlay" />
        <div className="home-featured__content">
          <span className="home-featured__tag">{item.label}</span>
          <h3 className="home-featured__title">{item.title}</h3>
        </div>
      </article>
    ))}
  </div>
);

export default HomeFeatured;
